import BackSvgComponent from "@assets/svg-components/back";
import InfoSvgComponent from "@assets/svg-components/info";
import { getColorStyle } from "@common/color";
import { getFirstLetterOfEachString } from "@common/text-helpers";
import { getValue } from "@utils/lodash";
import React from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";
function StickyHeader(props: any) {
  const navigate = useNavigate();
  const params = useParams();
  const { handleReject, handleSubmit, submitLoading, id, route, handleSendBack } = props;
  const getStatus = (status: string) => {
    switch (status) {
      case "unsubmitted":
        return "Unsubmitted";
      case "awaiting_approval":
        return "Awaiting Approval";
      case "approved":
        return "Approved";
      case "rejected":
        return "Rejected";
      case "reimbursed":
        return "Reimbursed";
      case "expired":
        return "Expired";
      case "archived":
        return "Archived";
      case "recalled":
        return "Recalled";
      case "sent_back":
        return "Sent Back";
      default:
        return "";
    }
  };
  const findCurrentApproverStausEnum = (arr: any) => {
    const currentApproverId = getValue(
      props,
      `formInfo.current_approver.id`,
      ""
    );
    const app =
      currentApproverId && getValue(arr, `length`, 0) > 0
        ? arr.filter(
            (item: object) =>
              String(getValue(item, `approver.id`, "")) ===
              String(currentApproverId)
          )
        : [];
    const awaitingApprover =
      getValue(arr, `length`, 0) > 0
        ? arr.find(
            (item: object) =>
              getValue(item, `approval_status`, "") === "awaiting_approval"
          )
        : null;
    return getValue(app, `length`, 0) > 0
      ? getValue(app, `[${0}].approval_status`, "")
      : getValue(
          awaitingApprover,
          `approval_status`,
          getValue(
            props,
            `formInfo.current_approver.approval_status`,
            getValue(props, `formInfo.approval_status`, "")
          )
        );
  };

  const currentApproverStatus = findCurrentApproverStausEnum(
    getValue(props, `formInfo.approvers`, "")
  );
  const currentUserId = getValue(props, `userInfo.id`, "");
  const hasCurrentUserId = Boolean(currentUserId);
  const isSentBackHistoryByCurrentUser = getValue(props, `histoyList`, []).some(
    (item: any) =>
      String(getValue(item, `description`, "")).toLowerCase().includes(
        "sent back"
      ) &&
      hasCurrentUserId &&
      String(
        getValue(
          item,
          `approver.id`,
          getValue(item, `approver`, getValue(item, `created_by.id`, ""))
        )
      ) === String(currentUserId)
  );
  const isSentBackCommentByCurrentUser =
    hasCurrentUserId &&
    String(getValue(props, `sentBackComment.created_by.id`, "")) ===
    String(currentUserId);
  const approvalStatus = getValue(props, `formInfo.approval_status`, "");
  const isAwaitingApproval =
    approvalStatus === "awaiting_approval" ||
    currentApproverStatus === "awaiting_approval";
  const displayApprovalStatus =
    approvalStatus === "unsubmitted" && isAwaitingApproval
      ? "awaiting_approval"
      : approvalStatus || currentApproverStatus;
  const showApprovalButtons =
    getValue(props, `userInfo.is_admin`, false) && isAwaitingApproval;
  const showSendBackButton =
    getValue(props, `userInfo.is_admin`, false) &&
    ["approved", "awaiting_approval"].includes(displayApprovalStatus);
  const showUndoSentBackButton =
    getValue(props, `userInfo.is_admin`, false) &&
    approvalStatus === "sent_back" &&
    (isSentBackCommentByCurrentUser || isSentBackHistoryByCurrentUser);

  return (
    <div className="common-sticky-header">
      <section className="inner-page-navigation-with-back-cta-buttons position-relative">
        <div className="container-fluid  d-flex justify-content-between align-items-center">
          <div className="d-flex justify-content-between align-items-center">
            <NavLink to={route ? `${route}` : "#"}>
              <BackSvgComponent />
            </NavLink>
            <p className="header_text"> {getValue(props, `title`, "")}</p>

            <h6
              className="ms-4"
              style={getColorStyle(
                displayApprovalStatus == "unsubmitted"
                  ? "draft"
                  : displayApprovalStatus
              )}
            >
              {getStatus(displayApprovalStatus)}
            </h6>
          </div>

          {getValue(props, `permissions`, []).includes("update") && (
            <div className="d-flex align-items-center">
              {showApprovalButtons && (
                <>
                  <button
                    className={`ascent-button ascent-button--header-buttons ascent-button--green`}
                    onClick={() => handleSubmit("approve")}
                    disabled={submitLoading}
                    style={{ fontWeight: "400" }}
                  >
                    Approve
                  </button>
                  <button
                    className={`ms-2 ascent-button ascent-button--header-buttons ascent-button--red`}
                    onClick={() => handleReject("reject")}
                    disabled={submitLoading}
                    style={{ fontWeight: "400" }}
                  >
                    Reject
                  </button>
                </>
              )}
              {showSendBackButton && (
                <button
                  className={`ms-2 ascent-button ascent-button--header-buttons ascent-button--orange`}
                  onClick={() => handleSendBack("sent-back")}
                  disabled={submitLoading}
                  style={{ fontWeight: "400" }}
                >
                  Send Back to user
                </button>
              )}
              {showUndoSentBackButton && (
                <button
                  className={`ms-2 ascent-button ascent-button--header-buttons ascent-button--secondary`}
                  onClick={() => handleSendBack("undo-sent-back")}
                  disabled={submitLoading}
                  style={{ fontWeight: "400" }}
                >
                  Undo Send Back
                </button>
              )}
              {!showApprovalButtons &&
                !showSendBackButton &&
                !showUndoSentBackButton && <div style={{ height: "48px" }} />}
            </div>
          )}

          <div className="d-flex align-items-center">
            {getValue(props, `histoyList.length`, 0) > 0 && (
              <div
                className="mx-2 border p-2 border-radius__5 d-flex align-items-center"
                onClick={props.toggleHistory}
              >
                <InfoSvgComponent color={"gray"} />
                <h6 className="header_text__16 cursor-pointer ms-1">History</h6>
              </div>
            )}
            {getValue(props, `permissions`, []).includes("update") && (
              <>
                {getValue(props, `formInfo.approval_status`, "") ==
                  "approved" && (
                  <button
                    className="reimbursement_button mx-2 px-2"
                    onClick={() =>
                      navigate(
                        `/admin/reports/reimbursement/${getValue(
                          params,
                          `id`,
                          ""
                        )}`
                      )
                    }
                  >
                    Record Reimbursement
                  </button>
                )}
              </>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}

export default StickyHeader;
